import { isDarkMode, isJ18Full } from "../assets";
import "./index.scss";
// 客户端接口isDarkMode()方法 黑暗模式返回true，浅色模式为false
let isDark: boolean;
export function getDarkMode(): boolean {
  return isDark;
}
export function setDarkMode(mode = false) {
  if (mode === isDark) return;
  document.body.classList.remove(
    isDark ? (isJ18Full ? "j18_full_dark" : "dark") : "light"
  );
  document.body.classList.add(
    mode ? (isJ18Full ? "j18_full_dark" : "dark") : "light"
  );
  isDark = mode;
  window.themeMode = mode;
}

(function init() {
  console.log("init");
  const Mode = isDarkMode;
  setDarkMode(Mode);
})();
